export default __webpack_public_path__ + "static/media/google_play_badge.b754c0d0.svg";